module.exports = __webpack_public_path__ + "img/btn-notice3.c291283e.png";